import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showCards } from '../../redux/gameSlice';
import './ShowCardsButton.css';

// "Show Cards" button shown in the action-bar slot during showdown / last-one-standing, letting
// the local player voluntarily reveal their own hole cards. Visibility timing:
//  - Regular showdown: available immediately (reveal out of order during the cycle).
//  - Won-by-fold (last standing): the winner gets it first after a 0.5s beat; everyone else
//    (incl. the winner) 0.5s after that, during the winner animation.
const WINNER_DELAY_MS = 500;
const ALL_DELAY_MS = 1000;

const ShowCardsButton = ({ roomId, wonByFold, isWinner }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(!wonByFold);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (!wonByFold) { setVisible(true); return; }
    setVisible(false);
    const t = setTimeout(() => setVisible(true), isWinner ? WINNER_DELAY_MS : ALL_DELAY_MS);
    return () => clearTimeout(t);
  }, [wonByFold, isWinner]);

  if (!visible || clicked) return null;

  return (
    <button
      className="show-cards-btn"
      onClick={() => { setClicked(true); dispatch(showCards({ roomId })); }}
    >
      Show Cards
    </button>
  );
};

export default ShowCardsButton;
